/* global teacherName */

export function getProjectTwitterText(options) {
    let userIsTeacherText;
    if (options && options.hasAutoDonationMatch) {
        userIsTeacherText = 'Donations to my classroom are currently being matched! ';
    } else {
        userIsTeacherText = "Check out my classroom on @DonorsChoose! I'd love your help to bring my project to life: ";
    }
    const userIsNotTeacherText = 'I love this teacher\'s idea for helping students: ';
    return getConciseShareText(options, userIsTeacherText, userIsNotTeacherText);
}

export function getTeacherProfileTwitterText(options) {
    const userIsTeacherText = 'Check out my classroom on @DonorsChoose! ';
    const userIsNotTeacherText = 'See ' + teacherName + '\'s classroom projects on @DonorsChoose: ';

    return getConciseShareText(options, userIsTeacherText, userIsNotTeacherText);
}

function getConciseShareText(options, userIsTeacherText, userIsNotTeacherText) {
    let text;
    if (options && options.isUserTheTeacher) {
        text = userIsTeacherText;
    } else {
        text = userIsNotTeacherText;
    }
    if (options && options.stripHandle) {
        text = text.replace(/@DonorsChoose/g, 'DonorsChoose');
    }
    return encodeURIComponent(text);
}

function getBasicMetadata() {
    const basicMetadata = {};
    basicMetadata.canonical_url = $("link[rel='canonical']").attr('href');
    basicMetadata.description = $("meta[name='description']").attr('content');
    basicMetadata.title = document.getElementsByTagName('title')[0].innerHTML;
    return basicMetadata;
}

function getTwitterMetadata() {
    const twitterMetadata = {};
    twitterMetadata.description = $("meta[name='twitter:description']").attr('content');
    twitterMetadata.card = $("meta[name='twitter:card']").attr('content');
    twitterMetadata.title = $("meta[name='twitter:title']").attr('content');
    twitterMetadata.site = $("meta[name='twitter:site']").attr('content');
    // Even though they are in the html <head>, I left these out because branch.io's endpoint doesn't care about these attributes
    // twitterMetadata["name"] = $("meta[name='twitter:name']").attr("content");
    // twitterMetadata["creator"] = $("meta[name='twitter:creator']").attr("content");
    // twitterMetadata["domain"] = $("meta[name='twitter:creator']").attr("content");
    return twitterMetadata;
}

export function redirectToTwitterWithShortenedUrl(fullUrl, longShareUrl) {
    const requestData = {};
    requestData.url = longShareUrl;
    requestData.basic_metadata = getBasicMetadata();
    requestData.twitter_metadata = getTwitterMetadata();
    getShortenedUrlAndRedirect(fullUrl, longShareUrl, requestData);
}

// Should work with any redirect, where the share url is a URL param, but must ensure the param name (e.g. "url") is correct
function getShortenedUrlAndRedirect(fullUrl, longShareUrl, requestData) {
    const newWindow = window.open('', '_blank');
    $.ajax({
        type: 'POST',
        contentType: 'application/json',
        url: `${secureBaseURL}common/shorten.html`,
        data: JSON.stringify(requestData),
        dataType: 'json',
        timeout: 1500,
        xhrFields: { withCredentials: true },
        success: function (data) {
            let socialMediaShareUrl = longShareUrl;
            if (data.hasOwnProperty('short')) {
                const shortShareUrl = data.short;
                if (shortShareUrl) {
                    socialMediaShareUrl = shortShareUrl;
                }
            }
            newWindow.location.href = (new Uri(fullUrl)).replaceQueryParam('url', socialMediaShareUrl).toString();
        },
        error: function () {
            // Timeout also ends up here
            newWindow.location.href = (new Uri(fullUrl)).replaceQueryParam('url', longShareUrl).toString();
        },
    });
}
